import { SaleSummaryContext } from "./sale-summary-context";
import React, { FC, HTMLAttributes, useContext } from "react";


const SaleSummaryBody: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const { saleSummaryModal, setScrollValue } =
    useContext<any>(SaleSummaryContext);

  function matchIndex(index: number, actualLength: number = 1) {
    return index === actualLength - 1;
  }

  function handleScroll(event: any) {
    setScrollValue(event.currentTarget.scrollTop);
  }
  return (
    <div className="sale-summary-body" onScroll={handleScroll}>
      {saleSummaryModal &&
        saleSummaryModal.SchemaData &&
        Object.keys(saleSummaryModal.SchemaData).length > 0 &&
        Object.keys(saleSummaryModal.SchemaData).map((objectKey, index) => {
          let saleObj = saleSummaryModal.SchemaData[objectKey];
          return (
            <div key={index}>
              <div className="flex px-[35px] py-15 bg-[#F2F5FA] text-[#6078A3] border-t border-[#707070]/[0.28]">
                <div className="flex-1">{saleObj.label}</div>
                {saleObj.rightSection && <div>{saleObj.rightSection}</div>}
              </div>
              {saleObj.fields &&
                saleObj.fields.length > 0 &&
                saleObj.fields.map((saleItem: any, i: number) => {
                  return (
                    <div
                      className={
                        "flex justify-between items-center px-[40px] text-14 " +
                        (matchIndex(i, saleObj?.fields?.length)
                          ? ""
                          : "border-b border-[#EBEBEB]") +
                        (saleItem?.highligthLabel ? " font-semibold " : "") +
                        (saleItem?.extraSpace ? " py-15 " : " py-10 ")
                      }
                      key={index}
                    >
                      <div className="pl-5">{saleItem.label}</div>
                      <div>{`${saleItem.amount}`}</div>
                    </div>
                  );
                })}
            </div>
          );
        })}
    </div>
  );
};

export default SaleSummaryBody;
